// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_ToggleFranquiaUsuarioInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /usuarios/toggleFranquiaUsuario
 *
 * Toggles franchise access for a user.
 */
import { registerContract } from './validate'

export interface Usuarios_ToggleFranquiaUsuarioInput {
sub: string
franquiaId: number
}

registerContract('Usuarios_ToggleFranquiaUsuarioInput', {
  sub:        { type: 'string',  required: true },
  franquiaId: { type: 'number',  required: true },
})
